const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://trainosys.sg/api";

const API_URL = `${API_BASE_URL}/products`;

export async function getProducts(page = 1, limit = 9, search = "") {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });

  if (search.trim()) {
    params.append("search", search.trim());
  }

  const response = await fetch(`${API_URL}?${params.toString()}`, {
    cache: "no-store",
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch products");
  }

  return response.json();
}

export async function trackCourseClick(id) {
  await fetch(`${API_URL}/${id}/click`, {
    method: "PATCH",
    cache: "no-store",
  });
}

export async function trackCourseSearch(ids) {
  await fetch(`${API_URL}/track-search/results`, {
    method: "PATCH",
    cache: "no-store",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ids }),
  });
}

export async function getCourseInsights() {
  const response = await fetch(`${API_URL}/insights/top`, {
    cache: "no-store",
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch course insights");
  }

  return response.json();
}

export async function getProductBySlug(slug) {
  const response = await fetch(`${API_URL}/slug/${slug}`, {
    cache: "no-store",
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch course");
  }

  return response.json();
}
